<template>
    <div class="background">
        <div style="background-color: #FFFFFF; width: 100%; height: 90%; margin: 10px 0 10px 10px">
            <el-row class="ticket_row">票种管理</el-row>
            <el-row>
                <el-col :span="5">
                    <div class="ticket_col2">*当前票种名称</div>
                    <div class="ticket_col">{{ tableData.info }}</div>
                </el-col>
                <el-col :span="5">
                    <div class="ticket_col2">*项目ID</div>
                    <div class="ticket_col">{{ tableData.id }}</div>
                </el-col>
                <el-col :span="5">
                    <div class="ticket_col2">*分类</div>
                    <div class="ticket_col">地球档案</div>
                </el-col>
                <el-col :span="5">
                    <div class="ticket_col2">*票种分类</div>
                    <div class="ticket_col">{{ tableData.ticketType }}</div>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="14" style="padding-left: 20px">
                    <div class="ticket_col2">*上架起止时间</div>
                    <div style="padding-left: 20px">
                        <el-date-picker
                            v-model="value1"
                            type="date"
                            placeholder="选择日期">
                        </el-date-picker>
                        <el-time-select
                            v-model="value"
                            :picker-options="{
                                start: '08:30',
                                step: '00:15',
                                end: '18:30'
                              }"
                            placeholder="选择时间">
                        </el-time-select>
                        至
                        <el-date-picker
                            v-model="value1"
                            type="date"
                            placeholder="选择日期">
                        </el-date-picker>
                        <el-time-select
                            v-model="value"
                            :picker-options="{
                                start: '08:30',
                                step: '00:15',
                                end: '18:30'
                              }"
                            placeholder="选择时间">
                        </el-time-select>
                    </div>
                    <div style="padding-left: 10px">
                        <i class="ticket_col2">限购</i>
                        <i class="ticket_col4">每个订单最大购买数量</i>
                    </div>
                    <div style="padding-left: 10px">
                        <el-input-number v-model="num" @change="handleChange" :min="1" :max="10"
                                         label="描述文字"></el-input-number>
                    </div>
                    <div>
                        <el-col :span="8">
                            <div class="ticket_col2">*票价实付</div>
                            <div class="ticket_col">{{ tableData.price }}</div>
                        </el-col>
                        <el-col :span="8">
                            <div class="ticket_col2">*票价划线价格</div>
                            <div class="ticket_col">{{ tableData.originalPrice }}</div>
                        </el-col>
                        <el-col :span="8">
                            <div class="ticket_col2">*库存</div>
                            <div class="ticket_col">1</div>
                        </el-col>
                    </div>
                    <div>
                        <div class="ticket_col2">状态</div>
                        <div style="padding-top: 10px">
                            <el-button @click="open" >下架当前票种</el-button>
                            <el-button @click="open">删除当前票种</el-button>
                        </div>
                    </div>
                </el-col>
                <el-col :span="10" style="padding-left: 10px">
                    <div class="ticket_col3">
                        首页卡片入口
                        <el-switch
                            v-model="value"
                            active-color="#13ce66"
                            inactive-color="#ff4949">
                        </el-switch>
                    </div>
                    <div class="ticket_col1">
                        <div class="ticket_col3">首页卡片图</div>
                        <div style="margin-left: 30%">
                            <el-upload
                                action="https://jsonplaceholder.typicode.com/posts/"
                                list-type="picture-card"
                                :on-preview="handlePictureCardPreview"
                                :on-remove="handleRemove">
                                <i class="el-icon-plus"></i>
                            </el-upload>
                            <el-dialog :visible.sync="dialogVisible">
                                <img width="100%" :src="dialogImageUrl" alt="">
                            </el-dialog>
                        </div>
                        <div class="ticket_col3">
                            核销地点信息
                            <el-input
                                style="padding-top: 10px"
                                type="textarea"
                                :rows="2"
                                placeholder="请输入内容"
                                v-model="textarea">
                            </el-input>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <el-row>
                <div style="text-align: center">
                   <el-button @click="button">取消</el-button>
                     <el-button @click="button">保存</el-button>
                </div>
            </el-row>
            <el-row>
            </el-row>
        </div>
    </div>
</template>

<script>
import $ from "jquery";

export default {
    name: "createTicketType",
    data() {
        return {
            tableData: {},
            num: 4,
            options: [{
                value: '选项1',
                label: '黄金糕'
            }, {
                value: '选项2',
                label: '双皮奶',
                disabled: true
            }, {
                value: '选项3',
                label: '蚵仔煎'
            }, {
                value: '选项4',
                label: '龙须面'
            }, {
                value: '选项5',
                label: '北京烤鸭'
            }],
            value: ''
        }
    },
    created() {

    },
    methods: {
        button(){
               this.$router.push(`ticketTypeList`)
        },
        open() {
        this.$confirm('是否删除此票种?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }
    },
    mounted() {
        var ticketTypeId = this.$route.query.id;
        var that = this
        $.ajax({
            // url: 'https://dreamportal.nextscene.cn/api/ticket/info',
            url: 'http://127.0.0.1:8002/api/ticket/info',
            type: 'GET',
            dataType: 'json',
            success: (res) => {
                console.log('获取到的数据：', res)
                let tableData = {}
                if (res.info == 'ok') {
                    res.orderList.forEach(function (ticketType) {
                        const result = ticketType.name.match(/【([^】]+)】/);
                        if (result && result.length > 1) {
                            var ticket_type = result[1];
                            console.log(ticket_type); // 输出：早鸟票
                        }
                        if (ticketType.id == ticketTypeId) {
                            tableData = {
                                id: ticketType.id,
                                info: ticketType.name,
                                category: '地球档案',
                                price: ticketType.price,
                                originalPrice: ticketType.originalPrice,
                                max_num: ticketType.max_num,
                                ticketType: ticket_type,
                                status: ticketType.status
                            }
                            that.num = ticketType.max_num
                        }

                    })
                    this.tableData = tableData
                }
            },
            error: (error) => {
                console.log('请求失败：', error)
            }
        })

    },
}
</script>

<style scoped>
.ticket_col {
    width: Fill (375px) px;
    height: Fixed (52px) px;
    padding: 8px 16px 8px 16px;
    gap: 10px;
    border-radius: 8px 8px 8px 8px;
    opacity: 0px;
    background: #EFF1F999;
    margin: 10px 10px 10px 10px;
}

.ticket_col1 {
    width: 380px;
    height: 422px;
    top: 211px;
    left: 775px;
    gap: 0px;
    border-radius: 18px 18px 18px 18px;
    opacity: 0px;
    border: 2px solid #2D334A4D;
    margin: 10px 0 0 0;
}

.ticket_row {
    width: 88px;
    height: 31px;
    font-family: PingFang SC;
    font-size: 20px;
    font-weight: 600;
    line-height: 30.8px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    margin: 20px 0 0 20px;
}

.ticket_col2 {
    width: 122px;
    height: 25px;
    font-family: PingFang SC;
    font-size: 17px;
    font-weight: 600;
    line-height: 25.2px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #8A96B1;
    margin: 20px 0 20px 20px;
}

.ticket_col3 {
    width: 236px;
    height: 25px;
    top: 231px;
    left: 798px;
    gap: 0px;
    opacity: 0px;
    font-family: PingFang SC;
    font-size: 18px;
    font-weight: 600;
    line-height: 25.2px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #8A96B1;
    padding: 10px 0 10px 10px

}

.ticket_col4 {
    font-family: PingFang SC;
    font-size: 13px;
    font-weight: 400;
    line-height: 21px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #8A96B1;

}

.background {
    background-color: #F4F5FA;
}
.iStyle1{
width: Fixed (180px)px;
height: Hug (62px)px;
padding: 17px 16px 17px 16px;
gap: 10px;
border-radius: 12px 12px 12px 12px;
opacity: 0px;
border: 2px solid #5C16F2;
    text-align: center;
}
.iStyle2{

}
</style>
